export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/hurt.01743d03.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};